import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MeterDistributorChangeService } from './services/meter-distributor-change.service';
import { MaintenanceService } from '@app/shared/services/api/maintenance.service';
import { MaintenanceSchedule } from '@app/shared/models/maintenance';
import { MaintenanceTypes, PermissionCode } from '@app/shared/enums';

@Component({
  selector: 'app-service-apps',
  templateUrl: './service-apps.component.html',
  styleUrls: ['./service-apps.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ServiceAppsComponent {
  public maintenanceTypes = MaintenanceTypes;
  public maintenanceStatus$: Observable<MaintenanceSchedule>;

  constructor(private _service: MeterDistributorChangeService, private maintenanceService: MaintenanceService, private _router: Router) {
    this.maintenanceStatus$ = this.maintenanceService.getMaintenanceSchedule(PermissionCode.SERVICES);
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }

  downloadExcel = (isMunicipalDiscount: boolean) => {
    this._service.downloadExcel(isMunicipalDiscount).subscribe();
  };
}
